import {DASHBOARD_API_URL, DASHBOARD_API_URL_TEST} from '../helpers';

export const verifySmsCode = async ({authRequestId, smsCode, test}:{authRequestId: string, smsCode: string, test?:boolean}) => {
	const body = {
		'sms-code': smsCode
	};

	const reqData = {
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Basic SMS_CODE:${authRequestId}`
		},
		method: 'POST',
		body: JSON.stringify(body)
	};

	const result = await fetch(`${test ? DASHBOARD_API_URL_TEST : DASHBOARD_API_URL}client_auth/${authRequestId}/token`, reqData);

	if (result.status >= 200 && result.status < 300) {
		const json = result.status === 204 ? null : await result.json();
		return {
			data: json,
			headers: result.headers,
			statusCode: result.status,
			ok:true
		};
	}
	if (result.status >= 400) {
		return {
			headers: result.headers,
			statusCode: result.status,
			error: result.statusText || 'Something went wrong',
			ok:false
		};
	}
	return {
		headers: result.headers,
		statusCode: result.status,
		error: result.statusText || 'Something went wrong',
		ok:false
	};
};

export const authUser = async ({authRequestId, method, test}:{authRequestId: string, method?: 'POST' | 'GET', test?:boolean}) => {
	const reqData = {
		headers: {
			'Content-Type': 'application/json'
		},
		method: method || 'POST'
	};
	try{
		const result = await fetch(`${test ? DASHBOARD_API_URL_TEST : DASHBOARD_API_URL}client_auth/${authRequestId}`, reqData);

		if (result.status >= 200 && result.status < 300) {
			const json = result.status === 204 ? null : await result.json();
			return {
				data: json,
				headers: result.headers,
				statusCode: result.status,
				ok: true
			};
		}
		if (result.status >= 400) {
			const json = [403, 404].includes(result.status) ? null : await result.json();
			return {
				headers: result.headers,
				statusCode: result.status,
				error: json?.message || result.statusText || 'Something went wrong',
				ok: false
			};
		}
		return {
			headers: result.headers,
			statusCode: result.status,
			error: result.statusText || 'Something went wrong',
			ok: false
		};
	}catch (e){
		return {
			statusCode: 500,
			error: 'Something went wrong',
			ok:false
		};
	}
};
